import React, { useEffect } from "react";
// import Header from "../components/dashboard/header";
import tmdbApi from "../api/tmdbApi";
import Footer from "./dashboard/footer";
import Header from "./dashboard/header";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import headerRight from "../assets/images/inst-right-image.svg"


const GeneralInstructions = (type = null) => {
  const navigate = useNavigate();
  let { id } = useParams();
  const { moduleid } = useParams();        // URL param
  const location = useLocation();          // state object
  const { moduleType } = location.state || {};
  const { pathologistid } = location.state || "";

  console.log('moduleid', id)
  console.log('moduleType', moduleType)
  console.log('location', location)
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const AgreeAndContinue = () => {


    if (moduleType === "fellowship") {
      navigate(`/fellowshipmodules/${id}`, {
        state: { pathologistid: pathologistid }
      });
    } else if (moduleType === "self") {

      navigate(`/usermoduleslibrary/${id}`);
    }
    else if (moduleType === "allmodules") {

      navigate(`/moduleslibrary/${id}`);
    } else if (moduleType === "mcqmodule") {

      navigate(`/mcqmoduleslibrary/${id}`);
    }else {
      NavigateRoute()
    }


  }
  const Cancel = () => {

    if (moduleType === "fellowship") {
      navigate("/fellowshipmodules")

    } else if (moduleType === "Timed Module" || moduleType === "self") {
      navigate("/usermoduleslibrary")

    } else if (moduleType === "allmodules") {

      navigate(`/moduleslibrary`);
    } else if (moduleType === "mcqmodule") {

      navigate(`/mcqmoduleslibrary`);
    }else {

    }

  }


  const NavigateRoute = async () => {
    navigate(`/timedmodule/${id}`, {
      state: { moduleType }
    });


  };

  return (
    <>
      <Header />
      <br />

      <div className="instructions-wapper">
        <div className="instructions-page instructions-modal">
          <div className="instructions-header">
            <h3 className="txt-48 text-light">
              INSTRUCTIONS FOR PARTICIPANTS <br />
              <span className="">
                Online Dermatopathology Diagnostic Module
              </span>
            </h3>
            <img src={headerRight} alt="" />
          </div>

          <div className="instructions-points">
            <p className="greeting">Dear Participant,</p>
            <p>
              Welcome to the Dermatopathology Diagnostic Module. Please read the
              following instructions carefully before beginning the cases.
            </p>

            {/* 1. Case Structure */}
            <div className="section">
              <h2>1. Case Structure</h2>
              <ul>
                <li>
                  <span className="link-bullet me-2">›</span>
                  A brief clinical history
                </li>
                <li>
                  <span className="link-bullet me-2">›</span>
                  Representative dermatopathology images (static or whole-slide)
                </li>
                <li>
                  <span className="link-bullet me-2">›</span>
                  Additional notes when applicable (e.g., PAS, Fite, IHC, special
                  stains)
                </li>
                <li>
                  <span className="link-bullet me-2">›</span>
                  Your task is to review the clinical–pathological information and
                  submit a single best diagnosis (or, in rare cases, two diagnoses
                  when indicated).
                </li>
              </ul>
            </div>

            {/* 2. How to Enter a Diagnosis */}
            <div className="section">
              <h2>2. How to Enter a Diagnosis</h2>
              <ul>
                <li>
                  <span className="link-bullet me-2">›</span>
                  Begin typing part of the diagnosis in the answer box.
                </li>
                <li>
                  <span className="link-bullet me-2">›</span>
                  The system will auto-populate a list of valid diagnoses from the
                  master diagnostic database.
                </li>
                <li>
                  <span className="link-bullet me-2">›</span>
                  You must choose your diagnosis only from this list.
                </li>
                <li>
                  <span className="link-bullet me-2">›</span>
                  Free-text answers are not permitted to ensure consistency and
                  accurate scoring.
                </li>
              </ul>
            </div>

            {/* 3. Single vs. Dual Diagnoses */}
            <div className="section">
              <h2>3. Single vs. Dual Diagnoses</h2>

              <h5 className="mt-3">A. Single-Diagnosis Cases (Most Cases)</h5>
              <ul>
                <li>
                  <span className="link-bullet me-2">›</span>
                  Leave the <em>“Two Diagnoses”</em> checkbox unticked.
                </li>
                <li>
                  <span className="link-bullet me-2">›</span>
                  Select one diagnosis from the auto-suggest list.
                </li>
              </ul>

              <h5 className="mt-3">B. Dual-Diagnosis Cases (Rare Cases)</h5>
              <ul>
                <li>
                  <span className="link-bullet me-2">›</span>
                  These cases truly have two co-existing diagnoses (e.g., lichen
                  simplex chronicus over psoriasis; granulomatous rosacea +{" "}
                  <em>Demodex</em>; nevus + dermatofibroma).
                </li>
                <li>
                  <span className="link-bullet me-2">›</span>
                  In such cases, there will be a checkbox labelled{" "}
                  <em>“This case has two diagnoses.”</em>
                </li>
                <li>
                  <span className="link-bullet me-2">›</span>
                  Tick the box and select both diagnoses from the
                  auto-suggestions.
                </li>
              </ul>

              <h5 className="mt-3">Marking Rules for the Dual-Diagnosis Feature</h5>
              <p>
                If the case truly has two diagnoses (as per the master answer
                sheet) and:
              </p>
              <ul>
                <li>
                  <span className="link-bullet me-2">›</span>
                  You correctly tick the two-diagnosis box and select both
                  diagnoses → full marks according to the weightage of each
                  diagnosis.
                </li>
                <li>
                  <span className="link-bullet me-2">›</span>
                  You fail to tick the two-diagnosis box → you lose marks
                  corresponding to the second diagnosis (based on its assigned
                  weight).
                </li>
              </ul>

              <p>
                If the case has only one diagnosis, and:
              </p>
              <ul>
                <li>
                  <span className="link-bullet me-2">›</span>
                  You incorrectly tick the two-diagnosis box → you lose half the
                  total marks for that case.
                </li>
              </ul>

              <p>
                These penalties ensure that the “two-diagnosis” option is used
                only when justified.
              </p>
            </div>

            {/* 4. Scoring and Marking */}
            <div className="section">
              <h2>4. Scoring and Marking</h2>
              <ul>
                <li>
                  <span className="link-bullet me-2">›</span>
                  Each case has either one or two correct diagnoses, based on
                  expert consensus.
                </li>
                <li>
                  <span className="link-bullet me-2">›</span>
                  Each diagnosis carries a predefined internal weight (e.g., 1.0
                  for primary, 0.5 for secondary).
                </li>
                <li>
                  <span className="link-bullet me-2">›</span>
                  Your selected diagnosis/diagnoses will be matched against the
                  master answer sheet.
                </li>
                <li>
                  <span className="link-bullet me-2">›</span>
                  Scoring is automated and proportional to how accurately you
                  match the reference answer.
                </li>
              </ul>
            </div>

            {/* 5. Answer Review, Explanation, and Contesting */}
            <div className="section">
              <h2>5. Answer Review, Explanation, and Contesting</h2>
              <p>Once you submit an answer, you will be shown:</p>
              <ul>
                <li>
                  <span className="link-bullet me-2">›</span>
                  The official correct diagnosis
                </li>
                <li>
                  <span className="link-bullet me-2">›</span>
                  A brief explanation with the key diagnostic features
                </li>
                <li>
                  <span className="link-bullet me-2">›</span>
                  Additional notes where relevant (e.g., pitfalls, teaching
                  points)
                </li>
              </ul>

              <p>You may:</p>
              <ul>
                <li>
                  <span className="link-bullet me-2">›</span>
                  Contest the answer if you believe an error has occurred
                </li>
                <li>
                  <span className="link-bullet me-2">›</span>
                  Submit feedback on the diagnosis list, image quality,
                  explanations, or platform functionality
                </li>
              </ul>

              <p>
                All feedback is welcomed and contributes to improving the system.
              </p>
            </div>

            {/* 6. Technical Guidance */}
            <div className="section">
              <h2>6. Technical Guidance</h2>
              <ul>
                <li>
                  <span className="link-bullet me-2">›</span>
                  Use a desktop or laptop for best viewing of histology.
                </li>
                <li>
                  <span className="link-bullet me-2">›</span>
                  Ensure a stable internet connection.
                </li>
                <li>
                  <span className="link-bullet me-2">›</span>
                  For assistance, please contact:{" "}
                  <em>admin@dermpathacademy.in or +91 76748 23911</em>
                </li>
              </ul>
            </div>

            <p className="closing">
              We look forward to your participation and thoughtful interpretations.
              <br />
              Thank you for contributing to collaborative learning in
              dermatopathology.
            </p>

            <p className="signature">
              Warm regards,
              <br />
              <strong>Dr. Sasi Kiran Attili</strong>
              <br />
              On behalf of DADI – Dermatopathology and Diagnostics India
              <br />
              <img
                src="https://dev.dermpathacademy.in/static/media/Dadi-logo.d4bbbf8e6e5218bb3024194748d15184.svg"
                width={240}
                alt=""
              />
            </p>
          </div>

          {/* Buttons */}
          <div className="d-flex justify-content-center align-items-center gap-3">
            <div className="d-flex flex-wrap justify-content-center gap-3 ms-0 ps-0 mt-0 mb-2 pb-4">
              <a className="register-link">
                <button
                  className="btn-fill-icon"
                  onClick={AgreeAndContinue}
                  type="button"
                >
                  <span className="material-symbols-outlined btn-icon-fill-style">
                    keyboard_arrow_right
                  </span>
                  Agree &amp; Continue
                </button>
              </a>
            </div>


            <div className="d-flex flex-wrap justify-content-center gap-3 ms-0 ps-0 mt-0 mb-2 pb-4">
              <a className="register-link">
                <button
                  className="btn-fill-icon"
                  onClick={Cancel}
                  type="button"
                >
                  <span className="material-symbols-outlined btn-icon-fill-style">
                    keyboard_arrow_right
                  </span>
                  Cancel
                </button>
              </a>
            </div>

          </div>
        </div>
      </div>

      <Footer />
    </>
  );

};

export default GeneralInstructions;
